export default __webpack_public_path__ + "static/media/Stage5_title.ae1bdc51.png";